import { useLoaderData } from '@remix-run/react';
import { EmployeeDetail } from '~/components/employee-detail.tsx';
import Section from '~/components/section.tsx';
import { type IndexLoaderData } from '../Types.ts';

export function Team() {
  const { team } = useLoaderData<IndexLoaderData>();

  return (
    <Section id="team" className="bg-white text-background">
      <div className="flex h-full w-full flex-col items-center justify-around sm:m-auto sm:max-w-[1400px] md:flex-row">
        {team.map((e) => (
          <EmployeeDetail key={e.name} employee={e} />
        ))}
      </div>
    </Section>
  );
}
